import React, { useContext, useState } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faCheck, faRightFromBracket, faQrcode,
    faUser, faSync, faTruckMoving, faUsers,
    faBuilding, faGlobe, faMap, faCity,
    faUserGroup, faLock,
    faTools
} from "@fortawesome/free-solid-svg-icons";
import * as Icon from 'react-bootstrap-icons';
import manifestoService from "../../services/ManifestoService";
import { MensagemModal } from "../../components/Components";

const Menu: React.FC = () => {
    const authContext = useContext(AuthContext);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');

    const handleStatusServico = () => {
        manifestoService.statusServico().then(res => {
            setShowAlert(true);
            setMessageAlert(`${res.xMotivo}  ${res.tpAmb == "2" ? " - Homologação": ""}`);

        }).catch(error => {
            setShowAlert(true);
            setMessageAlert(error.response.data.message);
        });
    }

    return (<>

        <Navbar bg="dark" variant="dark" expand="md" className="shadow-sm">
            <Container fluid={true} >
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/">Principal</Nav.Link>

                        <NavDropdown title="Manifesto" id="basic-nav-dropdown">
                            <NavDropdown.Item as={Link} to="/manifesto">
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faTruckMoving} className="text-primary me-1 "
                                    />
                                    <span className="">MDF-e</span>
                                </div>
                            </NavDropdown.Item>

                            <NavDropdown.Item as={Link} to={''} onClick={handleStatusServico} >
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faSync} className="text-success me-1 "
                                    />
                                    <span className="">Status do Serviço</span>
                                </div>
                            </NavDropdown.Item>

                            <NavDropdown.Item as={Link} to="/condutor">
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faUsers} className="text-warning me-1 "
                                    />
                                    <span className="">Condutores</span>
                                </div>
                            </NavDropdown.Item>
                            {authContext?.userLogado.is_superuser === 1 && (<>

                                <NavDropdown.Item as={Link} to="/empresa">
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon icon={faBuilding} className="text-success me-1 "
                                        />
                                        <span className="">Empresas</span>
                                    </div>
                                </NavDropdown.Item>

                                <NavDropdown.Item as={Link} to="/configs">
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon icon={faTools} className="text-dark me-1 "
                                        />
                                        <span className="">Configuração</span>
                                    </div>
                                </NavDropdown.Item>

                            </>)}


                            <NavDropdown.Divider />

                            <NavDropdown.Item as={Link} to="/pais">
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faGlobe} className="text-danger me-1 "
                                    />
                                    <span className="">Países</span>
                                </div>
                            </NavDropdown.Item>

                            <NavDropdown.Item as={Link} to="/estado">
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faMap} className="text-info me-1 "
                                    />
                                    <span className="">Estados</span>
                                </div>
                            </NavDropdown.Item>

                            <NavDropdown.Item as={Link} to="/municipio">
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faCity} className="text-success me-1 "
                                    />
                                    <span className="">Municipios</span>
                                </div>
                            </NavDropdown.Item>



                        </NavDropdown>
                        {authContext?.userLogado.is_superuser === 1 && (
                            <NavDropdown title="Segurança" id="basic-nav-dropdown">
                                <NavDropdown.Item as={Link} to="/profile">
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon icon={faUserGroup} className="text-primary me-1 "
                                        />
                                        <span className="">Perfis de usuário</span>
                                    </div>
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/user">
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="text-success me-1 "
                                        />
                                        <span className="">Usuários</span>
                                    </div>
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/permission">
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon icon={faLock} className="text-danger me-1 "
                                        />
                                        <span className="">Permissões</span>
                                    </div>
                                </NavDropdown.Item>
                            </NavDropdown>
                        )}
                    </Nav>

                    <Nav className="ms-auto" >
                        <NavDropdown title={<Icon.BuildingFillCheck className="" />}
                            id="basic-nav-dropdown" align="end" >

                            {authContext?.empresas?.map((empresa: any) => (
                                <NavDropdown.Item
                                    key={empresa.id} onClick={() => authContext.changeEmpresa(empresa.id)}  > {
                                        empresa.id.toString() === authContext?.empresa?.toString() ?
                                            <FontAwesomeIcon icon={faCheck} /> : ''
                                    } {empresa.xfant}</NavDropdown.Item>
                            ))}

                        </NavDropdown>
                    </Nav>


                    <Nav className="ms-2" >
                        <NavDropdown title={authContext?.user} id="basic-nav-dropdown" align="end">
                            {authContext?.userLogado.is_superuser === 1 && <NavDropdown.Item as={Link}
                                to="/licenca"> <FontAwesomeIcon icon={faQrcode}
                                    className="text-success" /> Licenças</NavDropdown.Item>}
                            {authContext?.isAuthenticated && <NavDropdown.Item onClick={authContext.logout}>
                                <FontAwesomeIcon className="text-danger"
                                    icon={faRightFromBracket} />  Sair</NavDropdown.Item>}
                        </NavDropdown>
                    </Nav>

                </Navbar.Collapse>
            </Container>
        </Navbar>
        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />

    </>);
}

export default Menu;